import {AppBaseProps, CommonApp, Entity} from "../../core/components/commonApp";
import {AppHelper} from "../../appHelper";
import {Helper} from "../../core/util/helper";
import {General} from "../../../siteManagement/general";
import {SheetEventType} from "../../../siteManagement/sheet";
import ExecuteAllAppLauncher, {ExecuteAllAppLauncherProps} from "./executeAllTasks";
import ExecutionsGridApp from "./executionsGrid";
import AssignmentsGridApp from "./assignmentGrid";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
export default class ExecutionsApp extends React.Component<ExecutionsAppProps, ExecutionsAppState> {
    private executionsGridRef: ExecutionsGridApp;
    private assignmentsGidRef: AssignmentsGridApp;
    common = new AppHelper();
    executionGridOptions: {};
    assignmentGridOptions: {};
    translations: StringKeyDictionary<string> = null;

    constructor(props: ExecutionsAppProps) {
        super(props);
        this.common.init(this);
        this.state = {
            filter: this.props.entity.ExecutionFilter,
            allCyclesTriggered: true
        }
    }

    // noinspection JSUnusedGlobalSymbols
    openExecuteAllTasks = async () => {
        const sheet = General.Sheet.Manager.createSheet();
        sheet.setTitle(Helper.getTranslation("WebCRM.Tasks.ExecuteAll.ScheduleIntervalls"));
        sheet.bind(SheetEventType.SavedSuccessfully, () => {
            this.setState({}, () => {
                this.common.sheetWrapper.trigger(SheetEventType.Custom, {event: "Reloading"});
            });
        });
        sheet.show(() => {
            const props: ExecuteAllAppLauncherProps = {
                isWindow: true,
                entityPreallocation: (filter) => {
                    let tillDate: string = "";
                    if (Helper.hasValue(this.state.filter.End)) {
                        tillDate = this.state.filter.End;
                    }
                    filter = {
                        TaskNo: this.state.filter.TaskNo,
                        TillDate: tillDate,
                        AddrNo: this.state.filter.AdrNr,
                        ProjNo: this.state.filter.ProjNr,
                        OGrNrs: this.state.filter.OGrNrs,
                        IndividualFields: this.state.filter.IndividualFields
                    };
                    return filter;
                },
                forwardingToAllExecutionsEnabled: false
            };
            sheet.mountContent(ExecuteAllAppLauncher, props);
            sheet.bind(SheetEventType.Close, () => {
                this.searchExecutions()
            })
        });
    }
    handleFieldChange = (field: { model: string }, value) => {
        switch (field.model) {
            case "entity.ExecutionFilter.Start":
            case "entity.ExecutionFilter.End":
            case "entity.ExecutionFilter.OnlyActive":
            case "entity.ExecutionFilter.AdrNr":
            case "entity.ExecutionFilter.ProjNr":
            case "entity.ExecutionFilter.OGrNrs":
            case "entity.ExecutionFilter.TaskNo":
                this.handleFilterChange(field, value);
                break;
            default:
                if (field.model.startsWith("entity.ExecutionFilter.IndividualFields"))
                {
                    this.handleFilterChange(field, value);
                }
        }
    }

    handleFilterChange(field: { model: string }, value) {
        let filter = this.state.filter;
        switch (field.model) {
            case "entity.ExecutionFilter.Start":
                filter = {...filter};
                filter.Start = value;
                break;
            case "entity.ExecutionFilter.End":
                filter = {...filter};
                filter.End = value;
                break;
            case "entity.ExecutionFilter.OnlyActive":
                filter = {...filter};
                filter.OnlyActive = value;
                break;
            case "entity.ExecutionFilter.AdrNr":
                filter = {...filter};
                filter.AdrNr = value;
                break;
            case "entity.ExecutionFilter.ProjNr":
                filter = {...filter};
                filter.ProjNr = value;
                break;
            case "entity.ExecutionFilter.TaskNo":
                filter = {...filter};
                filter.TaskNo = value;
                break;
            case "entity.ExecutionFilter.OGrNrs":
                filter = {...filter};
                filter.OGrNrs = value;
                break;
            default:
                if (field.model.startsWith("entity.ExecutionFilter.IndividualFields."))
                {
                    filter = {...filter, IndividualFields: {...filter.IndividualFields}};
                    let rest = field.model.replace("entity.ExecutionFilter.IndividualFields.", "");
                    filter.IndividualFields[rest] = value;
                }
        }
        this.setState({ filter: filter });
        this.common.handleFieldChange(field, value);
        this.common.setEntityDirtyState(false);
    }

    searchExecutions = async() => {
        await this.executionsGridRef.setExecutionInfos(this.state.filter);
        this.setState({ allCyclesTriggered: this.executionsGridRef.state.tasksToTriggerCount === 0 });
    }

    // noinspection JSUnusedGlobalSymbols
    renderExecutionsGridApp = () => {
        const entity: ExecutionsEntity = this.props.entity;
        entity.ExecutionFilter = this.state.filter;
        const context = {
            executionGridOptions: this.executionGridOptions,
            translations: this.translations
        };
        return <div style={{height: "400px"}}>
            <ExecutionsGridApp entity={entity} context={context} ref={(ref) => this.executionsGridRef = ref}
                               assignmentsGridRef={this.assignmentsGidRef} onSetParentState={() => {
                this.setState({allCyclesTriggered: this.executionsGridRef.state.tasksToTriggerCount === 0})
            }}/>
        </div>;
    }

    // noinspection JSUnusedGlobalSymbols
    renderAssignmentsGridApp = () => {
        const entity: Entity = {
            IsNew: this.props.entity.IsNew,
            IsWatchable: this.props.entity.IsWatchable,
            IsWatched: this.props.entity.IsWatched,
            RecordRight: this.props.entity.RecordRight,
            IndividualFields: this.props.entity.IndividualFields
        };
        const context = {
            assignmentGridOptions: this.assignmentGridOptions,
            translations: this.translations
        };
        return <div style={{height: "400px"}}>
            <AssignmentsGridApp entity={entity} context={context} ref={(ref) => this.assignmentsGidRef = ref}
                                executionsGridRef={this.executionsGridRef} onLoaded={() => {
                this.setState({})
            }}/>
        </div>;
    }

    // noinspection JSUnusedGlobalSymbols
    getTasksToTriggerLabel = () => {
        if (this.state.allCyclesTriggered)
            return null;
        const labelStyle: React.CSSProperties = {
            color: "#ff0000"
        }
        const text = Helper.getTranslation("WebCRM.Tasks.Executions.Msg.PrePlannedCycles");
        return <label style={labelStyle}>{text}</label>
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });

        return (<>
            <CommonApp {...props} />
        </>);
    }
}

export interface ExecutionsAppProps extends AppBaseProps {
    entity: ExecutionsEntity;
}

export interface ExecutionsEntity extends Entity {
    ExecutionFilter: ExecutionFilter;
    ExecutionMgmtEnabled: boolean;
    ForwardingToPreScheduleEnabled: boolean;
}

export interface ExecutionFilter {
    Start?: string;
    End: string;
    AdrNr?: string;
    ProjNr?: string;
    TaskNo?: string;
    OGrNrs: number[]; 
    OnlyActive: boolean;
    IndividualFields: { }
}

export interface ExecutionsAppState {
    filter: ExecutionFilter;
    allCyclesTriggered: boolean;
}